/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

import {
  ClientDto,
  CountryCode,
  HeliportEnvironment,
  PaginatedClientDto,
  UpdateClientRequest,
} from "../__ignore/schemas";

/**
 * @summary Get client
 */
export const getClientQueryIncludeDeletedDefault = false;

export const GetClientQueryParams = zod.object({
  includeDeleted: zod.coerce.boolean().default(getClientQueryIncludeDeletedDefault),
});

export const GetClientResponse = ClientDto;

/**
 * @summary Update client
 */
export const UpdateClientBody = UpdateClientRequest;

export const UpdateClientResponse = zod.void();

/**
 * @summary Delete client
 */
export const DeleteClientResponse = zod.void();

/**
 * @summary List clients
 */

export const listClientsQueryPerPageMax = 100;

export const listClientsQuerySortKeyDefault = `clientId`;
export const listClientsQueryStateDefault = `ACTIVE`;

export const ListClientsQueryParams = zod.object({
  page: zod.coerce.number().int().min(1).describe("Page number (1-indexed)"),
  perPage: zod.coerce
    .number()
    .int()
    .min(1)
    .max(listClientsQueryPerPageMax)
    .describe("Number of items per page"),
  q: zod.coerce.string().optional().describe("Free-text search query"),
  sortKey: zod
    .enum(["clientId", "companyName"])
    .default(listClientsQuerySortKeyDefault)
    .describe("Client sort key"),
  sortDir: zod.enum(["asc", "desc"]).optional().describe("Sort direction"),
  state: zod
    .enum(["ACTIVE", "DELETED", "ALL"])
    .default(listClientsQueryStateDefault)
    .describe("Client state filter"),
  countryCodes: zod.array(CountryCode).optional().describe("Client country filter"),
  environments: zod.array(HeliportEnvironment).optional().describe("Client environment filter"),
  createdFrom: zod.iso.datetime({offset: true}).optional().describe("Inclusive creation timestamp"),
  createdBefore: zod.iso
    .datetime({offset: true})
    .optional()
    .describe("Exclusive creation timestamp"),
});

export const ListClientsResponse = PaginatedClientDto;

/**
 * @summary Restore client
 */
export const RestoreClientResponse = zod.void();
